var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',{staticClass:"articles-counter",on:{"click":function($event){return _vm.openSidebar()}}},[_vm._v(_vm._s(_vm.articleIndex)+" / "+_vm._s(_vm.articleCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }